
export default {
	props:['title','subtitle','imgsrc'],
	computed: {
        url() {
            return window.location.origin;
        }
    },
}
